export default "__VITE_ASSET__1eeca06a__"